import gql from 'graphql-tag';

export const getCategories = gql`
  query getCategories {
    knowledgeBase {
      categories {
        name
        code
        hasSubcategories
      }
    }
  }
`;

export const getSubCategories = gql`
  query getSubCategories($categoryCode: String!) {
    knowledgeBase {
      subCategories(categoryCode: $categoryCode) {
        name
        code
        isArticle
      }
    }
  }
`;

export const getMetadata = gql`
  query getMetadata {
    knowledgeBase {
      metadata {
        name
        code
        tags
      }
    }
  }
`;

export const getArticlesByCategory = gql`
  query getArticles(
    $categoryCode: String!
    $subCategoryCode: String
    $articleType: Float!
  ) {
    knowledgeBase {
      articles(
        categoryCode: $categoryCode
        subCategoryCode: $subCategoryCode
        articleType: $articleType
      ) {
        code
        name
      }
    }
  }
`;

export const getArticle = gql`
  query getArticle($articleCode: String!) {
    knowledgeBase {
      article(articleCode: $articleCode) {
        code
        name
        html
      }
    }
  }
`;

export const sendFeedback = gql`
  mutation sendFeedback(
    $articleCode: String!
    $thumpsUp: Boolean!
    $feedback: String
  ) {
    sendFeedback(
      articleCode: $articleCode
      thumbsUp: $thumpsUp
      feedback: $feedback
    ) {
      status
    }
  }
`;
